import { ButtonProps } from "../@types/button";
import React from "react";
import { ButtonComponent } from "./button.styled";

export const Button: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <ButtonComponent {...props}>{children}</ButtonComponent>;
};
